//react
import React, { useState, useCallback, useEffect, useContext } from 'react';
import { sha256 } from 'js-sha256';
import { navigate } from 'hookrouter';

//Context API for User Info
import { InfoContext } from "./../context/InfoContext";

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

//images
import amr_logo_alt from './../assets/gmr_logo.png';
// get our fontawesome imports
import { faSearch, faUser, faSignOutAlt, faHospitalUser, faFileMedicalAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//pods
import MainNavbar from './MainNavbar';

//applications
import ManageUsers from './../applications/ManageUsers/ManageUsers';
import Charts from './../applications/Charts/Charts';


const Dashboard = () => {
    //current user Info
    const { info, setInfo } = useContext(InfoContext);    
    const [ activeApplication, setActiveApplciation ] = useState(null);

    //on component mount
    useEffect(() => {
        if(info === null) {
        navigate('/intro');
        } else {
        // fetchMostRecentRecords();
        }
    },[]);

    //on info loaded
    useEffect(() => {
        if(info === null) {
            navigate('/intro');
        } 
    },[info]);

    return (
        <div>
            <MainNavbar />
            <div className="mainBody">
                <Container fluid>
                    <Row lg={1}>
                        <Col>
                            <br />
                            { !activeApplication && <h4 className="mainHeader">Applications</h4> }
                            { activeApplication && <h4 className="mainHeader"><span className="activeLink" onClick={()=>setActiveApplciation(null)}>Applications</span> / {activeApplication}</h4> }

                        </Col>
                    </Row>
                    { !activeApplication && <Row>
                        { info && info.isAdmin && <Col md="auto">
                            <Card style={{ width: '18rem', height: '20rem' }}>
                                <br />
                                <div className="has-text-centered">
                                    <FontAwesomeIcon icon={faUser} color={'#3298DC'} size="5x" />
                                </div>
                                <Card.Body>
                                    <Container>
                                        <Row className="justify-content-md-center">
                                            <Card.Title>Manage Users</Card.Title>
                                        </Row>
                                    </Container>
                                    <Card.Text style={{height: '3rem' }}>
                                        Update user account settings, secuirty roles and business units access. 
                                    </Card.Text>
                                    <hr />
                                    <Container>
                                        <Row className="justify-content-md-center">
                                            <Button variant="primary" block onClick={()=>setActiveApplciation("Manage Users")}>Manage</Button>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                        </Col> }
                        <Col>
                            <Card style={{ width: '18rem', height: '20rem' }}>
                                <br />
                                <div className="has-text-centered">
                                    <FontAwesomeIcon icon={faFileMedicalAlt} color={'#00D1B2'} size="5x" />
                                </div>
                                <Card.Body>
                                    <Container>
                                        <Row className="justify-content-md-center">
                                            <Card.Title>CO / PA</Card.Title>
                                        </Row>
                                    </Container>
                                    <Card.Text style={{height: '3rem' }}>
                                        Review Active Charts. 
                                    </Card.Text>
                                    <hr />
                                    <Container>
                                        <Row className="justify-content-md-center">
                                            <Button variant="primary" block onClick={()=>setActiveApplciation("Charts")}>Review</Button>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row> }
                    {/* Set Active Application Below */}
                    {
                        {
                            'Manage Users': <ManageUsers />,
                            'Charts': <Charts />
                        }[activeApplication]
                    }

                </Container>
                <hr />        
                { !activeApplication && <div className="card">
                    <iframe 
                        width="100%" 
                        height="541.25" 
                        src="https://app.powerbi.com/reportEmbed?reportId=cf73a9fe-890d-4ebc-8651-f6a06b340942&autoAuth=true&ctid=8f7636bb-81ad-4268-bf87-f1aef06a7278&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtYi1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9" 
                        frameborder="0" 
                        allowFullScreen="true"
                    />
                </div> }
            </div>
        </div>
    );
};
export default Dashboard;

